import LaunchIcon from "@mui/icons-material/Launch";
import { Box, Link, Stack, Typography } from "@mui/material";
import {
  required,
  TextInput,
  useGetIdentity,
  useRecordContext,
  useTranslate,
} from "react-admin";
import { Buyer } from "../types";

const DIAS_ATENDIMENTO = ["seg", "ter", "qua", "qui", "sex", "total"] as const;

export function BuyersInputs() {
  const record = useRecordContext<Buyer>();
  const isEdit = record?.id != null;

  return (
    <Stack gap={1} sx={{ width: "100%" }}>
      {isEdit && <BuyerPersonLink />}
      <TextInput source="nome_razao" validate={required()} helperText={false} />
      <TextInput
        source="nome_fantasia"
        validate={required()}
        helperText={false}
      />
      <TextInput
        source="email"
        validate={required()}
        type="email"
        helperText={false}
      />
      {isEdit && <FornecedoresPorDia />}
    </Stack>
  );
}

const BuyerPersonLink = () => {
  const record = useRecordContext<Buyer>();
  const { identity } = useGetIdentity();
  const baseUrl = identity?.homologacao
    ? "https://sandbox.rnge.com.br/app/index.html#/"
    : "https://app.rnge.com.br/#/";

  if (record?.id == null) return null;

  return (
    <Stack direction="row" alignItems="center" gap={1} mb={1}>
      <Typography variant="caption" color="text.secondary">
        ID
      </Typography>
      <Link
        href={`${baseUrl}persons/${record.id}`}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        variant="body2"
        onClick={(e) => e.stopPropagation()}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        {record.id}
        <LaunchIcon sx={{ fontSize: 16 }} />
      </Link>
    </Stack>
  );
};

const FornecedoresPorDia = () => {
  const record = useRecordContext<Buyer>();
  const translate = useTranslate();
  if (!record) return null;

  return (
    <Stack gap={0.5} mt={1}>
      <Typography variant="subtitle2">
        Fornecedores atendidos por dia
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Quantidade de fornecedores sob este comprador em cada dia da semana
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap" mt={0.5}>
        {DIAS_ATENDIMENTO.map((source) => (
          <Box
            key={source}
            sx={{
              minWidth: 72,
              px: 1,
              py: 0.75,
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              textAlign: "center",
            }}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
            >
              {translate(`resources.buyers.fields.${source}`)}
            </Typography>
            <Typography
              variant="body1"
              fontWeight={source === "total" ? 700 : 500}
            >
              {record[source] ?? 0}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};
